import React, {useState} from 'react';

function HomeCard(props) {

    const [view, setView] = useState(false);
    const [viewValue, setValue] = useState('View more');

    function handleClick(e) {
        e.preventDefault();
        setView((prevState) => {
            if (prevState) {
                return false;
            } else {
                return true;
            }
        });
    }

    return (
        <div className="home-card">
            <div className="card-img">
                <img src={props.img} alt=""/>
            </div>
            <div className="card-content">
                <h1 className="card-title">{props.title}</h1>
                <div className="card-description">
                    <p>
                        {   view ? props.content
                            :
                            props.description
                        }
                    </p>
                </div>
                <div className="card-links">
                    <a href="#" className="card-more link" onClick={handleClick}>{view ? 'View less' : 'View more'}</a>
                    <a className="card-author link" href={props.authorUrl}>{props.author}</a>
                </div>
                <h3 className="card-date">{props.published}</h3>
            </div>
        </div>
    );
}

export default HomeCard;